import { ServiceCard, ServiceCardProps } from 'ui/Card';
import { TextL, TextS } from 'ui/Styled/Styled';
import FormField from 'ui/FormField/FormField';
import { useFormState, useForm } from 'react-final-form';
import { useMemo } from 'react';
import * as S from './About.styled';
import { Button } from 'ui/Button';
import { moneyFormatter } from 'utils/intl';

type PayModalProps = {
    options: ServiceCardProps[];
};

export function PayModal({ options }: PayModalProps) {
    const { values } = useFormState();
    const form = useForm();
    const [total, quantity] = useMemo(() => {
        if (!values) {
            return [0, 0];
        }

        return options.reduce(
            (acc, option) => {
                const quantity = Number(values[`quantity`]?.[option.no] ?? 0);

                return [acc[0] + option.price * quantity, acc[1] + quantity];
            },
            [0, 0]
        );
    }, [options, values]);

    return (
        <>
            <S.Header>
                <TextL>Корзина</TextL>
            </S.Header>
            <S.Body>
                {options.map((option) => (
                    <S.CardRow key={option.no}>
                        <S.CardContainer>
                            <ServiceCard
                                showNo={false}
                                key={option.title}
                                {...option}
                            />
                        </S.CardContainer>
                        <S.FieldContainer>
                            <FormField
                                center
                                onlyInput
                                height="100%"
                                type="number"
                                name={`quantity[${option.no}]`}
                                defaultValue="0"
                            />
                        </S.FieldContainer>
                    </S.CardRow>
                ))}
            </S.Body>
            <S.Footer>
                <S.TotalRow>
                    <TextS>Итого: {moneyFormatter.format(total)}</TextS>
                    <TextS>Кол-во: {quantity}</TextS>
                </S.TotalRow>
                <Button onClick={form.submit}>Оплатить</Button>
            </S.Footer>
        </>
    );
}
